import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { LoginForm } from 'components/LoginForm'

const Login = () => {
    return (
        <>
            <Container fluid className="login-page">
                <Row>
                    <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={5}
                        className="container-left d-flex align-items-center justify-content-center"
                    >
                        <LoginForm />
                    </Col>
                    <Col xs={0} sm={0} md={12} lg={7} className='d-xs-none d-sm-none d-md-none d-lg-block container-right'/>
                </Row>
            </Container>
        </>
    )
}

export default Login
